import { useContainer } from '../../useContainer';
import { ClientApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpDeleteClient = (clientId: string, callback?: ICallback) => {
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const { exec } = clientApi.delete({
        params: { id: clientId },
        onSuccess: _ => {
            toastHandler.push('success', 'Client Deletion', 'Client deletion request successfuly sent');
            if (callback) {
                if (callback.onSuccess) callback.onSuccess();
            }
        },
        onError: _ => toastHandler.push('success', 'Client Deletion', 'Client deletion failed.'),
    });
    return { executeDelete: exec };
};

export default useHttpDeleteClient;
